<template>
  <b-list-group-item class="py-1 px-0">
    <slot />
  </b-list-group-item>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'AdvancedScrollListItem',
  setup() {
    return {}
  }
})
</script>
